export enum PARTICIPANT_MEETING_STATUS {
  VIEWING = 'VIEWING',
  IN_MEETING = 'IN_MEETING',
}

export interface ParticipantMeetingStatusProps {
  status?: PARTICIPANT_MEETING_STATUS;
  isInline?: boolean;
}
